import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

// Schemas: SurveySubmission / SurveyForm (verified against
// SCHEMA_REFERENCE.json — same entities hr-surveys/hr-survey-form-creation
// manage; this module is the employee's "my submissions" filtered view).
/** Latest change first by default, like the old `GetMySurveySubmissions` `{ LastUpdateDate: -1 }` sort. */
export const DEFAULT_MY_SURVEY_SUBMISSIONS_ORDER: OrderBy[] = [
  { field: 'LastUpdatedDate', direction: 'DESC' },
];

export const buildGetMySurveySubmissionsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_MY_SURVEY_SUBMISSIONS_ORDER
) => `
  query {
    SurveySubmissions: getSurveySubmissions(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        SurveyBatchId
        SurveyFormId
        SurveyTitle
        SurveyDescription
        UserId
        UserName
        UserEmail
        Deadline
        RequestedDateUtc
        SubmittedDateUtc
        Timezone
        Status
        AnswersJson
      }
    }
  }
`;

// HasSections/SectionsJson are required here too: without them, answering a
// sectioned survey form would render an empty question list (only
// QuestionsJson would be read, which is empty for sectioned forms).
export const buildGetSurveyFormLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    SurveyForms: getSurveyForms(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      items {
        ItemId
        Title
        HasSections
        QuestionsJson
        SectionsJson
      }
    }
  }
`;
